/* eslint-disable complexity */
import { Termin_Wochentage } from '@/gql/graphql';
import { t } from 'i18next';

export enum TerminWochentage {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const WOCHENTAGE: { value: TerminWochentage; labelKey: string }[] = [
  { value: TerminWochentage.MONDAY, labelKey: 'monday' },
  { value: TerminWochentage.TUESDAY, labelKey: 'tuesday' },
  { value: TerminWochentage.WEDNESDAY, labelKey: 'wednesday' },
  { value: TerminWochentage.THURSDAY, labelKey: 'thursday' },
  { value: TerminWochentage.FRIDAY, labelKey: 'friday' },
  { value: TerminWochentage.SATURDAY, labelKey: 'saturday' },
  { value: TerminWochentage.SUNDAY, labelKey: 'sunday' },
];

export type Wochentage = typeof WOCHENTAGE;

export const terminWochentageToGraphQLMap: Record<
  TerminWochentage,
  Termin_Wochentage
> = {
  [TerminWochentage.MONDAY]: Termin_Wochentage.Monday,
  [TerminWochentage.TUESDAY]: Termin_Wochentage.Tuesday,
  [TerminWochentage.WEDNESDAY]: Termin_Wochentage.Wednesday,
  [TerminWochentage.THURSDAY]: Termin_Wochentage.Thursday,
  [TerminWochentage.FRIDAY]: Termin_Wochentage.Friday,
  [TerminWochentage.SATURDAY]: Termin_Wochentage.Saturday,
  [TerminWochentage.SUNDAY]: Termin_Wochentage.Sunday,
} as const satisfies Record<TerminWochentage, Termin_Wochentage>;

export function getLocalWeekdayTranslation(weekday: TerminWochentage) {
  if (weekday === 'MONDAY') {
    return t('general.date.days.mondayShort');
  }
  if (weekday === 'TUESDAY') {
    return t('general.date.days.tuesdayShort');
  }
  if (weekday === 'WEDNESDAY') {
    return t('general.date.days.wednesdayShort');
  }
  if (weekday === 'THURSDAY') {
    return t('general.date.days.thursdayShort');
  }
  if (weekday === 'FRIDAY') {
    return t('general.date.days.fridayShort');
  }
  if (weekday === 'SATURDAY') {
    return t('general.date.days.saturdayShort');
  }
  if (weekday === 'SUNDAY') {
    return t('general.date.days.sundayShort');
  }
}
